function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "current",
  d: "M55,74.8c-17.6,0-31.1-15.5-31.3-15.8h0s0,0,0,0h0c-1.4-1.7-1.4-4.2,0-5.9.6-.7,14-17.2,31.3-17.2s30.8,16.5,31.3,17.2c1.4,1.8,1.4,4.2,0,5.9-.1.2-13.7,15.8-31.3,15.8ZM27.1,56.3c.2.3,12.4,14.1,27.9,14.1s27.8-14,27.9-14.1c0-.1,0-.3,0-.4-.5-.6-12.6-15.6-27.9-15.6s-27.4,15-27.9,15.6c-.1.1-.1.3,0,.4Z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "current",
  d: "M54.4,38.3c7.8,0,14.1,6.3,14.1,14s-6.3,14-14.1,14c-7.8,0-14.1-6.3-14.1-14s6.3-14,14.1-14ZM61.2,43.7c-2.2,0-4,1.8-4,4,0,2.2,1.8,4,4,4,2.2,0,4-1.8,4-4,0-2.2-1.8-4-4-4Z"
});

var SvgIcoSimulationCategoryEyes = function SvgIcoSimulationCategoryEyes(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 110 110",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcoSimulationCategoryEyes, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico_simulation_category_eyes.cf8e626e.svg";
export { ForwardRef as ReactComponent };